import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
    selector: "app-terms-display",
    standalone: true,
    imports: [CommonModule],
    template: `
        <textarea
            class="form-control terms-display"
            [id]="inputId"
            [rows]="rows"
            [value]="value || ''"
            disabled
            readonly></textarea>
    `,
    styles: [
        `
            :host {
                display: block;
            }

            .terms-display {
                resize: none;
                overflow-y: auto;
                overflow-x: hidden;
                white-space: pre-wrap;
                word-break: break-word;
                height: auto;
                min-height: calc(1.5em + 0.75rem + 2px);
            }
        `,
    ],
})
export class TermsDisplayComponent {
    @Input() inputId: string = "termsDisplay";
    @Input() value: string | null | undefined = "";

    get rows(): number {
        if (!this.value) return 2;
        const lines = this.value.split(/\r?\n/).length;
        const wrappedEstimate = Math.ceil(this.value.length / 80);
        return Math.max(2, Math.min(20, Math.max(lines, wrappedEstimate)));
    }
}
